import { Button, Form, Input } from "antd";
import EditIcon from "../../../assets/icons/EditIcon";
import shebaLogo from "../../../assets/images/logo/sheba.svg";
import InfoItemTwo from "../../../components/common/sidebar/InfoItemTwo";
import EmployeeFileUpload from "../../../components/Employees/EmployeeFileUpload";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function Footer() {
  const [form] = Form.useForm();
  const onFinish = (values: any) => {};
  return (
    <SidebarLayout title="Website CMS - Footer">
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="grid md:grid-cols-520 gap-6">
          <div className="bg-white border border-extra-light p-6 max-w-[712px] rounded-md">
            <p className="text-[#2d3643] text-[22px] font-semibold leading-[35px] mb-6">
              Footer
            </p>
            <div
              className={`bg-[#F0F3F9] flex justify-between items-center border-b px-3 py-2.5 border-[#8897AE] font-medium rounded-t-md`}
            >
              <h4 className="text-display-body ">Pages Name/Title</h4>

              <div className="text-display-body ">Action</div>
            </div>
            <InfoItemTwo
              title="Pricing"
              children={
                <span className="text-[#4A72FF]">
                  <EditIcon />
                </span>
              }
            />
            <InfoItemTwo
              title="Stories"
              children={
                <span className="text-[#4A72FF]">
                  <EditIcon />
                </span>
              }
            />
            <InfoItemTwo
              title="Contact"
              rootClassName="rounded-b-md"
              children={
                <span className="text-[#4A72FF] ">
                  <EditIcon />
                </span>
              }
            />
            <Form.Item
              name=""
              label="Contact Number"
              className="my-4 "
              rules={[
                {
                  required: true,
                  message: "Please enter contact",
                },
              ]}
            >
              <Input prefix="+880" placeholder="017xxx xxxx xxx" />
            </Form.Item>
            <Form.Item
              name=""
              label="Email Address"
              className="my-4 "
              rules={[
                {
                  required: true,
                  message: "Please enter email address",
                },
              ]}
            >
              <Input placeholder="example@gmail.com" />
            </Form.Item>
            <Form.Item
              name=""
              label="Address"
              className="my-4 "
              rules={[
                {
                  required: true,
                  message: "Please enter address",
                },
              ]}
            >
              <Input placeholder="H#454, R#31, Mohakhali DOHS, Dhaka-1206, Bangladesh." />
            </Form.Item>
            <div className="">
              <Form.Item
                name="nid_image_front"
                label="Logo"
                className="my-4 "
                valuePropName="fileUrl"
                rules={[
                  {
                    required: true,
                    message: "Please upload NID photo",
                  },
                ]}
              >
                <EmployeeFileUpload
                  form={form}
                  accept=".png, .jpg, .jpeg"
                  name="nid_image_front"
                  // onChange={(url) =>
                  //   form.setFieldsValue({
                  //     nid_image_front: url,
                  //   })
                  // }
                />
              </Form.Item>
              <div className="w-[120px] h-[84.22px]">
                <img src={shebaLogo} alt="" className="cover-full " />
              </div>
            </div>
            <Button className="middle-button mt-6" type="primary">
              Update
            </Button>
          </div>

          <div className="bg-white border border-extra-light p-6 max-w-[712px] rounded-md">
            <p className="text-[#2d3643] text-[22px] font-semibold leading-[35px]">
              Social Link
            </p>

            <div className="mt-6">
              <Form.Item
                name="fb"
                label="Facebook"
                className="mb-4"
                rules={[
                  {
                    required: true,
                    message: "Please enter a link",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="www.facebook.com"
                  prefix="https://"
                />
              </Form.Item>
              <Form.Item
                name="youtube"
                label="Youtube"
                className="mb-4"
                rules={[
                  {
                    required: true,
                    message: "Please enter a link",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="www.Youtube.com"
                  prefix="https://"
                />
              </Form.Item>
              <Form.Item
                name="fb"
                label="Linkedin"
                className="mb-4"
                rules={[
                  {
                    required: true,
                    message: "Please enter a link",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="www.linkedin.com"
                  prefix="https://"
                />
              </Form.Item>
              <Form.Item
                name="fb"
                label="Instagram"
                className="mb-4"
                rules={[
                  {
                    required: true,
                    message: "Please enter a link",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="www.instagram.com"
                  prefix="https://"
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>
    </SidebarLayout>
  );
}
